const t = "Cửa sổ phương thức", s = "Đóng", c = {
  title: t,
  close: s
};
export {
  s as close,
  c as default,
  t as title
};
